import { IonSpinner } from '@ionic/react';
import cs from 'classnames';

import styles from './ServiceLoader.module.scss';

import { ServiceTypes } from '../../constants/service';
import { State } from '../../constants/state';

export interface ServiceLoaderProps {
  service: ServiceTypes;
  state: State;
}

export const ServiceLoader = ({ state, service }: ServiceLoaderProps) => {
  const stateBackgroundClass = cs({
    [styles.checkmark]: true,
    [styles.error]: state == State.Error,
    [styles.success]: state == State.Successful,
    [styles.loading]: state == State.Loading || state == State.Indeterminate
  });

  return (
    <section className={styles.logo}>
      <div className={styles.dashedConnection}>
        <div className={styles.iconContainer}>
          <div className={styles.circleBadge}>
            <img src="/img/gitlive-logo.svg" />
          </div>

          <div className={stateBackgroundClass}>
            {state == State.Loading && (
              <IonSpinner
                color="light"
                name="circles"
                style={{ color: 'white', transform: 'scale(0.75)' }}
              />
            )}

            {state == State.Indeterminate && (
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                version="1.1"
                data-view-component="true"
                className="octicon octicon-arrow-switch"
              >
                <path d="M5.22 14.78a.75.75 0 0 0 1.06-1.06L4.56 12h8.69a.75.75 0 0 0 0-1.5H4.56l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3Zm5.56-6.5a.75.75 0 1 1-1.06-1.06l1.72-1.72H2.75a.75.75 0 0 1 0-1.5h8.69L9.72 2.28a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3Z"></path>
              </svg>
            )}

            {state == State.Successful && (
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                version="1.1"
                data-view-component="true"
                className="octicon octicon-check"
              >
                <path
                  fillRule="evenodd"
                  d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
                ></path>
              </svg>
            )}

            {state == State.Error && (
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                version="1.1"
                data-view-component="true"
                className="octicon octicon-cross"
              >
                <path d="M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"></path>
              </svg>
            )}
          </div>

          <div className={styles.circleBadge}>
            <img src={`/img/${service}.svg`} />
          </div>
        </div>
      </div>
    </section>
  );
};
